import React from "react";
import PesquisaSatisfacaoController from "../controller/pesquisa-satisfacao.controller";
import PerguntaEvento from "./PerguntaEvento";

interface Props {
  controller: PesquisaSatisfacaoController;
}

export default function PesquisaSatisfacao({ controller }: Props) {
  const lista = controller.lista;
  
  return (
    <>
      <div className="pesquisa-satisfacao-wrapper">
        <div className="pesquisa-satisfacao-intro">
          <p className="pesquisa-satisfacao-intro__text">
            Nos ajude a melhorar
          </p>
        </div>
        <div className="pesquisa-satisfacao-questions">
          {lista.map((m: any) => (
            <PerguntaEvento
              send={controller.send}
              onChange={(value: any) =>
                controller.onChange({
                  cdPergunta: m.cdSeqPergunta,
                  dsResposta: value,
                })
              }
              key={m.cdSeqPergunta + "pergunta"}
              pergunta={m}
            />
          ))}
        </div>
      </div>
    </>
  );
}
